// extracted by mini-css-extract-plugin
module.exports = {"topicList":"TheoryTopicsListContainer_topicList__1VkRq"};